import Page from "../components/Page";

export default function ErrorPage() {
  return <Page>ERROR, SOMETHING WENT WRONG</Page>;
}
